module.exports = __webpack_public_path__ + "img/图层 21.ea36073b.png";